import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// Design system — tokens first, then scoped foundations, then primitive styles.
import './ui/tokens/tokens.css';
import './ui/foundations/foundations.css';
import './ui/components'; // side-effect: registers all primitive CSS

import './index.css';
import App from './App';
import { AuthProvider, useAuth } from './auth/AuthContext';
import { I18nProvider } from './i18n';
import { ToastProvider } from './ui/components';

/** Feeds the signed-in user's saved language preference into the i18n layer. */
function LocalizedApp() {
  const { user } = useAuth();
  return (
    <I18nProvider language={user?.language}>
      <App />
    </I18nProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <AuthProvider>
          <LocalizedApp />
        </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
